// extracted by mini-css-extract-plugin
export default {"container":"SecureData_container__993Bj","logo":"SecureData_logo__AEGoz","title":"SecureData_title__c4kHG","text":"SecureData_text__38ZYo"};